import React from "react";

const AddNew = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="12.936" height="12.936" viewBox="0 0 12.936 12.936">
			<path
				id="icons8-add-new"
				d="M15.4,4H5.54A1.541,1.541,0,0,0,4,5.54V15.4a1.541,1.541,0,0,0,1.54,1.54H15.4a1.541,1.541,0,0,0,1.54-1.54V5.54A1.541,1.541,0,0,0,15.4,4Zm-1.232,6.776H10.776v3.388H10.16V10.776H6.772V10.16H10.16V6.772h.616V10.16h3.388Z"
				transform="translate(-4 -4)"
				fill="#fff"
			/>
		</svg>
	);
};

export default AddNew;
